import React from 'react';
import styled from 'styled-components/macro';
import { FairBarInfo } from '../interfaces/fairBar-info';

interface Props {
	fairInfo: FairBarInfo;
}

const FairInfoBar = ({ fairInfo }: Props) => {
	const formatDate = (apiDate: string) => {
		return `${apiDate.substring(5, 7)}/${apiDate.substring(8, apiDate.length)}/${apiDate.substring(2, 4)}`;
	};

	return (
		<FairBarWrapper>
			<FairBarTable>
				<FairInfoHeader>{fairInfo.name}</FairInfoHeader>
				<FairInfoText>
					Fair Dates: {formatDate(fairInfo.fairStartDate)}-{formatDate(fairInfo.fairEndDate)}
				</FairInfoText>
				<FairInfoText>Fair ID: {fairInfo.id}</FairInfoText>
			</FairBarTable>
		</FairBarWrapper>
	);
};

const FairBarWrapper = styled.div`
	background-color: #f4f4f4;
	display: flex;
	flex-direction: column;
	height: 85px;
	width: 100%;
	border-bottom: 5px solid #e0e0e0;
`;

const FairBarTable = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-left: 180px;
	@media (max-width: 800px) {
		margin-left: calc((100% - 440px) / 2);
	}
	@media (max-width: 480px) {
		margin-left: 20px;
	}
`;

const FairInfoHeader = styled.h1`
	color: #333;
	font-size: 15px;
	font-weight: 600;
	letter-spacing: 1.5px;
	line-height: 15px;
	margin: 14px 0 2px 0;
	text-decoration: none;
	text-transform: none;
	text-transform: capitalize;
`;

const FairInfoText = styled.p`
	color: #666;
	font-size: 13px;
	font-weight: 400;
	margin: 5px 0 0 0;
	text-decoration: none;
	text-transform: none;
`;

export default FairInfoBar;
